var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box f-c-c"},[_c('img',{attrs:{"src":"https://img.kakaclo.com/web-img/404.png"}}),_c('div',{},[_vm._v(_vm._s(_vm.$t('Index.page404.Tips1')))]),_c('el-button',{on:{"click":function($event){return _vm.jumpHref('/mall')}}},[_vm._v(_vm._s(_vm.$t('Index.page404.GoBack')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }